module.exports = __webpack_public_path__ + "static/media/gno.1b1f4dea.svg";